/**
 * SummaryPolicies
 *
 * Collapsible policy sections below the Step 5 appointment summary: Cancellation
 * policy (market-driven), Arrival Window, and Valet Policy (static copy). Reuses
 * the shared Accordion. Mirrors the mantis checkout policy list, minus Community
 * Guidelines (not in this Figma).
 *
 * The Cro Sprint policy Figma differs from the shared Accordion's service-detail
 * defaults, corrected here (scoped to this section so the service-detail hero is
 * unaffected): the block sits on a white ground below the sand trust banner, the
 * chevron points down when collapsed / up when expanded, and hairline dividers
 * fall between rows only (none above the first, none below the last).
 */
import React from 'react'
import { trackCheckoutPolicyOpened } from '../../../../helpers/tracking'
import styled from '@emotion/styled'
import Accordion from '../../../service-detail/Accordion'
import { gsColors } from '../../../../styles/Variables'
import { ARRIVAL_WINDOW_POLICY, DEFAULT_VALET_POLICY } from './policyCopy'

const Wrapper = styled.div`
  width: 100%;
  padding: 0 24px 24px;
  background-color: ${gsColors.white};

  & > div:last-child {
    border-bottom: none;
  }

  .chevron {
    transform: rotate(0deg);
  }

  .chevron.open {
    transform: rotate(180deg);
  }
`

/** Shows market policies and records each explicit policy open. */
const SummaryPolicies = ({ cancellationPolicy, market }) => (
  <Wrapper>
    {cancellationPolicy && (
      <Accordion title="Cancellation policy" onOpen={() => trackCheckoutPolicyOpened({ policy: 'cancellation', market, step: 5 })}>{cancellationPolicy}</Accordion>
    )}
    <Accordion title="Arrival Window" onOpen={() => trackCheckoutPolicyOpened({ policy: 'arrival_window', market, step: 5 })}>{ARRIVAL_WINDOW_POLICY}</Accordion>
    <Accordion title="Valet Policy" onOpen={() => trackCheckoutPolicyOpened({ policy: 'valet', market, step: 5 })}>{DEFAULT_VALET_POLICY}</Accordion>
  </Wrapper>
)

export default SummaryPolicies
